import React from "react";
import types from "./types";

const Template = ({ size, color, variant, ...props }) => (
  <svg
    fill="none"
    width={size}
    height={size}
    viewBox="0 0 24 24"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    {variant === "outline" && (
      <path
        d="M7.414 17.9708L17.556 7.82879L16.142 6.41479L6 16.5568V17.9708H7.414ZM8.243 19.9708H4V15.7278L15.435 4.29279C15.6225 4.10532 15.8768 4 16.142 4C16.4072 4 16.6615 4.10532 16.849 4.29279L19.678 7.12179C19.8655 7.30931 19.9708 7.56362 19.9708 7.82879C19.9708 8.09395 19.8655 8.34826 19.678 8.53579L8.243 19.9708Z"
        fill={color}
      />
    )}

    {variant === "default" && (
      <path
        d="M8.243 19.9708H4V15.7278L15.435 4.29279C15.6225 4.10532 15.8768 4 16.142 4C16.4072 4 16.6615 4.10532 16.849 4.29279L19.678 7.12179C19.8655 7.30931 19.9708 7.56362 19.9708 7.82879C19.9708 8.09395 19.8655 8.34826 19.678 8.53579L8.243 19.9708Z"
        fill={color}
      />
    )}
  </svg>
);

Template.propTypes = types.propTypes;
Template.defaultProps = types.defaultProps;

export default Template;
